import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { getUiLanguage, tr } from '../lib/i18n';
import { Link as RouterLink, useLocation } from 'react-router-dom';

function crumbsFor(pathname: string): { label: string; to?: string }[] {
  if (pathname.startsWith('/properties/')) return [{ label: tr('العقارات', 'Properties'), to: '/properties' }, { label: tr('تفاصيل العقار', 'Property details') }];
  if (pathname.startsWith('/requests/')) return [{ label: tr('الطلبات', 'Requests'), to: '/requests' }, { label: tr('تفاصيل الطلب', 'Request details') }];
  if (pathname.startsWith('/dashboard')) return [{ label: tr('لوحة التحكم', 'Dashboard') }];
  if (pathname.startsWith('/new')) return [{ label: tr('إدخال جديد', 'New entry') }];
  if (pathname.startsWith('/properties')) return [{ label: tr('العقارات', 'Properties') }];
  if (pathname.startsWith('/requests')) return [{ label: tr('الطلبات', 'Requests') }];
  if (pathname.startsWith('/users')) return [{ label: tr('الموظفون', 'Employees') }];
  if (pathname.startsWith('/roles')) return [{ label: tr('الأدوار والصلاحيات', 'Roles & permissions') }];
  if (pathname.startsWith('/settings')) return [{ label: tr('إعدادات الشركة', 'Organization settings') }];
  if (pathname.startsWith('/notifications')) return [{ label: tr('الإشعارات', 'Notifications') }];
  return [];
}

/** Page title for top-level pages; a breadcrumb trail for nested ones. */
export function AppBreadcrumbs() {
  const { pathname } = useLocation();
  const items = crumbsFor(pathname);
  if (!items.length) return null;
  if (items.length === 1) {
    return (
      <Typography component="h1" noWrap sx={{ fontSize: { xs: '1.375rem', md: '1.625rem' }, fontWeight: 600, lineHeight: 1.3, color: 'text.primary', minWidth: 0 }}>
        {items[0]!.label}
      </Typography>
    );
  }
  return (
    <Breadcrumbs aria-label={tr('مسار الصفحة', 'Breadcrumbs')} separator={getUiLanguage() === 'ar' ? <NavigateBeforeIcon fontSize="small" /> : <NavigateNextIcon fontSize="small" />} sx={{ minWidth: 0 }}>
      {items.map((item, i) => {
        const last = i === items.length - 1;
        if (last || !item.to) {
          return (
            <Typography key={item.label} variant="body2" color="text.secondary" noWrap>
              {item.label}
            </Typography>
          );
        }
        return (
          <Link key={item.to} component={RouterLink} to={item.to} variant="body2" color="primary" fontWeight={500} noWrap>
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
